<script>
  export default {
    name: 'Modal',
    props: ['next', 'sign', 'accept', 'name'],
    data() {
      return {
        isModalVisible: false,
        //nextURL: "",
        //signURL: "",
        //acceptURL: "",
      }
    },
    methods: {
      closeYes() {
        let tmpYURL = this.next;
        $.ajaxSetup({
          headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') }
        });
        $.ajax({
         type: "POST",
         url: this.sign,
         data: { sign: true} ,
           success(data) {
             //alert(tmpYURL);
             window.location.href = tmpYURL;
             return false;
           },
         error(data) {
           return false;
         }
        });
        this.$emit('close');
      },
      closeNo() {
        this.$emit('close');
      }
    },
  };
</script>

<template>
  <div class="modal" tabindex="-1" role="dialog" style="display:block;">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body" style="color:black;text-align:center;">
          <slot name="body">
          {{ $t('javascript.modal.would_you_like_to') }}
          <h1 style="font-family: Ephesis, Regular;">{{name}}</h1>
          </slot>
         </div>

        <div class="modal-footer justify-content-center" style="text-align: center;">
          <button
            type="button"
            class="btn btn-primary btn-nomargin"
            @click="closeYes"
          >
            {{ $t('javascript.modal.yes_attach') }}
          </button>
          <br>
          <slot name="footer">
            <small style="color: black;">
              {{ $t('javascript.modal.the_final_pdf') }}
            </small>
          </slot>

        </div>
      </div>
    </div>
  </div>
</template>


